import { RootState } from "../../store";

export default function getReconnectionError({ user }: RootState) {
  return user.reconnectionError;
}
